import React, { SVGProps } from 'react';
import {
  Box, Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import { Accordion, AccordionDetails, AccordionSummary } from '../SidebarAccordion.component';

import { ReactComponent as BookedIcon } from './booked.svg';
import { ReactComponent as BookableByYouIcon } from './bookable-by-you.svg';
import { ReactComponent as BookableByAnyoneIcon } from './bookable-by-anyone.svg';
import { ReactComponent as DateOverrideIcon } from './date-override.svg';
import { ReactComponent as OutOfOfficeIcon } from './out-of-office.svg';


const Item = ({ icon: Icon, title, details }: { icon: React.ComponentType<SVGProps<SVGSVGElement>>; title: string; details?: string }) => {
  return (
    <Box display="flex" gap="8px" alignItems="flex-start">
      <Box style={{ width: 24 }}>
        <Icon style={{ width: 24, height: 24 }} />
      </Box>
      <Box>
        <Typography style={{ lineHeight: '26px' }}>
          {title}
        </Typography>
        <Typography color="textSecondary">
          {details}
        </Typography>
      </Box>
    </Box>
  );
};


const SchedulingDetails: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" gap="16px">
      <Item icon={BookedIcon} title="Booked" />
      <Item icon={BookableByYouIcon} title="Bookable By You" details="Only you can book these blocks" />
      <Item icon={BookableByAnyoneIcon} title="Bookable By Anyone" details="New clients and you can book these weekly blocks" />
      <Item icon={DateOverrideIcon} title="Date Override" details="One-time modifications to your Weekly Availability—affects new clients only" />
      <Item icon={OutOfOfficeIcon} title="Out of Office" details="This does not remove or block your availability." />
    </Box>
  );
};


export const SidebarDetails: React.FC = () => {
  return (
    <Accordion elevation={0} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography style={{ fontWeight: 600 }}>Calendar Key</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <SchedulingDetails />
      </AccordionDetails>
    </Accordion>
  );
};
